// Config do Mesa QR lida uma vez por carregamento do painel (quase nunca muda):
//  - useMesaQrLigado: a loja usa o Mesa QR? (pergunta do nome do QR ao renomear)
//  - useSaidaQrLigada: a saída pelo QR está ligada? Os botões "Ler QR de
//    saída" só aparecem com o "Pagamento na mesa" ligado em Preferências E o
//    PIX Online de Mesas (dono, 24/09/2026) — antes bastava o Mesa QR ligado.
import { useEffect, useState } from "react";

import { lerConfig } from "./api";

let cache = null;
let pedido = null;

function useCampoDaConfig(ler) {
  const [valor, setValor] = useState(cache ? ler(cache) : false);
  useEffect(() => {
    if (cache) return undefined;
    let vivo = true;
    pedido = pedido || lerConfig().then(({ data }) => { cache = data || {}; return cache; });
    pedido.then((c) => { if (vivo) setValor(ler(c)); }).catch(() => { pedido = null; });
    return () => { vivo = false; };
  }, [ler]);
  return valor;
}

const ligado = (c) => !!c?.enabled;
const saidaLigada = (c) => !!c?.pagamento_mesa;

export const useMesaQrLigado = () => useCampoDaConfig(ligado);
export const useSaidaQrLigada = () => useCampoDaConfig(saidaLigada);
